<template>
    <dialog @close="handleClose" @cancel="handleClose">
        <a href="javascript:void(0)" class="close" @click.prevent="$el.close()">
            <i class="fas fa-times" />
        </a>
        <div ref="content" class="dlg-content">
            <slot></slot>
        </div>
    </dialog>
</template>
<script>

import dialogPolyfill from 'dialog-polyfill'

export default {
  name: 'modal',
  props: ['show'],
  data () {
    return {
      resizeable: false,
    }
  },
  watch: {
    show(newval, oldval) {
      if (!!newval) {
        this.showModal()
      }
      else {
        this.close()
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('closed');
    },
    close () {
      this.$el.close();
    },
    showModal () {
      this.$el.showModal();

      if (!this.$el.style.minHeight && this.resizeable) {
        let w = this.$el.clientWidth;
        let h = this.$el.clientHeight;


        this.$el.style.minHeight = h + 'px';
        this.$el.style.minWidth = w + 'px';

        this.heightDiff = h - this.$refs.content.clientHeight;
      }

    },
  },
  mounted () {
    if (!window.HTMLDialogElement) {
      dialogPolyfill.registerDialog(this.$el)
      this.$el.classList.add('polyfill')
    }
  },
}
</script>
<style lang="scss">
dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.35);
}
dialog + .backdrop {
  background-color: rgba(0, 0, 0, 0.35);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
dialog {
  position: fixed;
  top: 50%;
  bottom: auto;
  transform: translate(0, -50%);
  border: none;
  box-shadow: 0 0 0 1px #000;
  background: white;

  &:not([open]) {
    display: none;
  }

  &.polyfill {
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 1rem;
    margin: 0;
  }

  .close {
    box-shadow: none;
    outline: none;
    position: absolute;
    top: 8px;
    right: 8px;
  }

  form label {
    font-size: 0.925rem;
    select {
      display: block;
    }
  }
}
</style>
